import { Container, Stack, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Footer from "splash_components/Splash/CommonComponents/Footer";
import { NavigationBar } from "splash_components/Splash/CommonComponents/NavigationBar";

import React from "react";
import { tSplash } from "locales/splash/cruxTranslation";

export default function HomeWallSplash() {
  const theme = useTheme();
  const textColor = theme.palette.primary.contrastText;

  return (
    <div style={{ backgroundColor: "#F4F4F1", backgroundImage: "url('/topography.svg')", userSelect: "text" }}>
      {screen.width < theme.breakpoints.values.sm ? (
        // Mobile
        <>
          <NavigationBar theme={theme} mobile />
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(5),
            }}
          >

            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
                sx={{ width: "100%" }}
              >
                <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "75px" }} />
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  <b>
                    {tSplash("homewalls.title")}
                  </b>
                </Typography>
              </Stack>
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {tSplash("homewalls.subtitle")}
              </Typography>
              <Stack direction="column" alignItems="center" spacing={2}>
                <a href="/ios">
                  <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_app_store_alt")} src={tSplash("common.buttons.download_on_app_store_image")} />
                </a>
                <a href="/android">
                  <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_google_play_alt")} src={tSplash("common.buttons.download_on_google_play_image")} />
                </a>
              </Stack>
            </Stack>
          </Container>
          <Box
            pb={theme.spacing(5)}
            pt={theme.spacing(5)}
          >
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <video
                  src="https://assets.climbwithcrux.com/ai-demo-woody.mp4"
                  style={{
                    maxHeight: "60vh",
                    maxWidth: "100%",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", marginTop: "32px !important" }}
                >
                  {tSplash("homewalls.ai_setting_header")}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {tSplash("homewalls.ai_setting_text_1")}
                </Typography>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(5)} pt={theme.spacing(5)} sx={{ backgroundColor: theme.palette.primary.main, backgroundImage: "url('/topography.svg')" }} >
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <video
                    src="https://assets.climbwithcrux.com/filter.mp4"
                    style={{
                      maxHeight: "60vh",
                      maxWidth: "100%",
                      maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                      maskSize: "contain",
                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                  <Typography
                    variant="h5"
                    sx={{ textAlign: "center", marginTop: "32px !important" }}
                    color={textColor}
                  >
                    {tSplash("homewalls.search_header")}
                  </Typography>
                  <Typography sx={{ textAlign: "center" }} color={textColor}>
                    {tSplash("homewalls.search_text_1")}
                  </Typography>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(5)} pt={theme.spacing(5)}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <video
                  src="https://assets.climbwithcrux.com/profile.mp4"
                  style={{
                    maxHeight: "60vh",
                    maxWidth: "100%",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />

                <Typography
                  variant="h5"
                  sx={{ textAlign: "center", marginTop: "32px !important" }}
                >
                  {tSplash("homewalls.track_progress_header")}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {tSplash("homewalls.track_progress_text_1")}
                </Typography>
                <Stack direction="column" alignItems="center" spacing={2}>
                  <a href="/ios">
                    <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_app_store_alt")} src={tSplash("common.buttons.download_on_app_store_image")} />
                  </a>
                  <a href="/android">
                    <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_google_play_alt")} src={tSplash("common.buttons.download_on_google_play_image")} />
                  </a>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Footer theme={theme} />
        </>
      ) : (
        // Desktop
        <>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
            }}
          >
            <NavigationBar theme={theme} mobile={false} />
            <Box pt={theme.spacing(12)} pb={theme.spacing(3)}>
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
              >
                <Stack direction="row" justifyContent="center" alignItems="center">
                  <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "100px" }} />
                </Stack>

                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="h2" sx={{ textAlign: "center", fontWeight: 900, maxWidth: "800px" }}>
                    {tSplash("homewalls.title")}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
                  >
                    {tSplash("homewalls.subtitle")}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="center"
                  sx={{ width: "100%" }}
                  spacing={2}
                >
                  <a href="/ios">
                    <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_app_store_alt")} src={tSplash("common.buttons.download_on_app_store_image")} />
                  </a>
                  <a href="/android">
                    <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_google_play_alt")} src={tSplash("common.buttons.download_on_google_play_image")} />
                  </a>
                </Stack>
              </Stack>
            </Box>
            <Box
              pb={theme.spacing(7)}
              pt={theme.spacing(7)}

            >
              <Container
                style={{
                  paddingLeft: theme.spacing(6),
                  paddingRight: theme.spacing(6),
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={6}
                >
                  <Stack direction="column" spacing={2} sx={{ width: "35%" }}>
                    <Typography variant="h3" sx={{
                      fontWeight: 700,
                      fontSize: "2rem",
                    }}>
                      {tSplash("homewalls.ai_setting_header")}
                    </Typography>
                    <Typography variant="h6" sx={{
                      fontWeight: 400
                    }}>
                      {tSplash("homewalls.ai_setting_text_1")}
                    </Typography>
                  </Stack>
                  <video
                    src="https://assets.climbwithcrux.com/ai-demo-woody.mp4"
                    style={{
                      maxHeight: "60vh",
                      maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                      maskSize: "contain",
                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </Stack>
              </Container>
            </Box>
          </Container>
          <Box pb={theme.spacing(7)} pt={theme.spacing(7)} sx={{ backgroundColor: theme.palette.primary.main, backgroundImage: "url('/topography.svg')" }}>
            <Container
              style={{
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
              }}
            >
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={6}
              >
                <video
                  src="https://assets.climbwithcrux.com/filter.mp4"
                  style={{
                    maxHeight: "60vh",
                    maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                    maskSize: "contain",
                  }}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <Stack direction="column" spacing={2} sx={{ width: "35%" }} alignItems="flex-start">
                  <Typography variant="h3" color={textColor} sx={{
                    fontWeight: 700,
                    fontSize: "2rem"
                  }}>
                    {tSplash("homewalls.search_header")}
                  </Typography>
                  <Typography variant="h6" color={textColor} sx={{
                    fontWeight: 400
                  }}>
                    {tSplash("homewalls.search_text_1")}
                  </Typography>
                </Stack>
              </Stack>
            </Container>
          </Box>
          <Box pb={theme.spacing(7)} pt={theme.spacing(7)} >
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={6}
            >
              <Stack direction="column" spacing={2} sx={{ width: "35%" }}>
                <Typography variant="h3" sx={{
                  fontWeight: 700,
                  fontSize: "2rem"
                }}>
                  {tSplash("homewalls.track_progress_header")}
                </Typography>
                <Typography variant="h6" sx={{
                  fontWeight: 400
                }}>
                  {tSplash("homewalls.track_progress_text_1")}
                </Typography>
                <Stack
                  direction="row"
                  sx={{ width: "100%" }}
                  spacing={2}
                >
                  <a href="/ios">
                    <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_app_store_alt")} src={tSplash("common.buttons.download_on_app_store_image")} />
                  </a>
                  <a href="/android">
                    <img style={{ height: "46px", maxHeight: "46px" }} alt={tSplash("common.buttons.download_on_google_play_alt")} src={tSplash("common.buttons.download_on_google_play_image")} />
                  </a>
                </Stack>
              </Stack>
              <video
                src="https://assets.climbwithcrux.com/profile.mp4"
                style={{
                  maxHeight: "60vh",
                  maskImage: "url(https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/d0385491-c935-4e28-680d-992562031c00/public)",
                  maskSize: "contain",
                }}
                autoPlay
                loop
                muted
                playsInline
              />
            </Stack>
          </Box>
          <Footer theme={theme} />
        </>
      )
      }
    </div >
  );
}
